import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import axios from "../axios";
import { ServicesList } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  Checkbox,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";

export default function ServiceList() {
  const navigation = useNavigate();
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [data, setData] = useState<ServicesList>({
    response: [],
  });
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(0);

  useEffect(() => {
    axios.get("/services?limit=" + limit + "&page=" + page).then((res) => {
      setData(res.data);
    });
  }, [refresh, limit, page]);

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newSelectedIds: number[] = [];

    if (event.target.checked) {
      newSelectedIds = data.response!.map((row) => row.id!);
    } else {
      newSelectedIds = [];
    }

    setSelectedIds(newSelectedIds);
  };

  const handleSelectOne = (
    _event: React.ChangeEvent<HTMLInputElement>,
    id?: number
  ) => {
    const selectedIndex = selectedIds.indexOf(id!);
    let newSelectedIds: number[] = [];

    if (selectedIndex === -1) {
      newSelectedIds = newSelectedIds.concat(selectedIds, id!);
    } else if (selectedIndex === 0) {
      newSelectedIds = newSelectedIds.concat(selectedIds.slice(1));
    } else if (selectedIndex === selectedIds.length - 1) {
      newSelectedIds = newSelectedIds.concat(selectedIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedIds = newSelectedIds.concat(
        selectedIds.slice(0, selectedIndex),
        selectedIds.slice(selectedIndex + 1)
      );
    }

    setSelectedIds(newSelectedIds);
  };

  const handlePageChange = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage?: number
  ) => {
    if (newPage !== null) {
      setPage(newPage!);
    }
  };

  const handleLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(Number(event.target.value));
  };

  const count = () => {
    if (data.meta !== undefined && data.meta.total !== undefined) {
      return data.meta.total;
    } else {
      return 0;
    }
  };

  const onDelete = () => {
    const result = window.confirm("削除しますか？");
    if (!result) {
      return;
    }
    selectedIds.forEach((id: number) => {
      axios
        .delete("/services/" + id)
        .then((res) => {
          console.log(res);
          setRefresh(!refresh);
        })
        .catch((err) => {
          alert(err.response.data.message);
        });
    });
    const newSelectedIds: number[] = [];
    setSelectedIds(newSelectedIds);
  };

  const onCreate = () => {
    navigation("/services/create");
  };

  const dateValue = (date: Date | undefined) => {
    if (date !== undefined) {
      return date!.toString().substring(0,19).replace('T', ' ');
    } else {
      return "";
    }
  };

  const tableView = (
    <React.Fragment>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                checked={selectedIds.length === data.response?.length}
                color="primary"
                indeterminate={
                data.response !== null
                ? selectedIds.length > 0 &&
                selectedIds.length < data.response!.length
                                   : false
                }
                onChange={handleSelectAll}
              />
            </TableCell>
            <TableCell>ID</TableCell>
            <TableCell>サービスID</TableCell>
            <TableCell>サービス名</TableCell>
            <TableCell>作成日時</TableCell>
            <TableCell>更新日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.response?.map((row) => (
            <TableRow key={row.id}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedIds.indexOf(row.id!) !== -1}
                  onChange={(event) => handleSelectOne(event, row.id)}
                  value="true"
                />
              </TableCell>
              <TableCell>
                <Link to={"/services/" + row.id}>{row.id}</Link>
              </TableCell>
              <TableCell>{row.service_id}</TableCell>
              <TableCell>{row.service_name}</TableCell>
              <TableCell>{dateValue(row.created_at)}</TableCell>
              <TableCell>{dateValue(row.updated_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={count()}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[50, 100, 200]}
      />
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={() => onCreate()} sx={{ m: 1 }}>
          CREATE
        </Button>
        <Button color="primary" variant="contained" onClick={() => onDelete()} sx={{ m: 1 }}>
          DELETE
        </Button>
      </Grid>
    </React.Fragment>
  );

  return (
    <Dashboard title="サービス管理">
      <br />
      {data.response == null || data.response?.length === 0 ? (
        <div>
          No Service Data
          <br/><br/>
          <Grid item xs={12}>
            <Button color="primary" variant="contained" onClick={() => onCreate()} sx={{ m: 1 }}>
              CREATE
            </Button>
          </Grid>
        </div>
      ) : (
        tableView
      )}
    </Dashboard>
  );
}
